const config = {
  apiGateway: {
    REGION: 'us-east-1',
    INTERNAL_API_URL: 'https://bu66n7jumc.execute-api.us-east-1.amazonaws.com/prod',
    TARGET_API_URL: 'https://fkejs9ozp5.execute-api.us-east-1.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.rossing.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.rossing.forwoodsafety.com'
  }
};

export default config;